import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-6xl mx-auto px-4 py-20 text-center">
      <h1 className="text-3xl font-extrabold">404</h1>
      <p className="text-slate-600 mt-2">Page not found.</p>

      <Link
        className="inline-block mt-6 px-5 py-3 rounded-xl bg-blue-600 text-white font-bold hover:opacity-95"
        to="/"
      >
        Back to Home
      </Link>
    </div>
  );
}
